import { CoreServicesClient, GET } from '@virtus/common/core-services/CoreServicesClient';
import axios, { AxiosResponse } from 'axios';
import config from 'src/config';
import { useSignalR } from './SignalRConnector';

export type ExecuteCallback = (err: any, resStatus: number, resBody: any, resText: string, resHeaders: object) => void;

export type NetworkHandler = {
  execute: (callback: ExecuteCallback) => void;
  abort: () => void;
};

export type NetworkInterface = (
  url: string,
  method: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE',
  config?: { body?: string | object; headers?: object; credentials?: 'omit' | 'include' },
) => NetworkHandler;

interface Config {
  apiUrl: string;
  clientId: string;
  signalrUrl?: string;
  signalrClientId?: string;
  signalrApiUrl?: string;
  onUnauthorized?: () => void;
  getUsername: () => string;
  isGlideAuth?: boolean;
  useIDP?: boolean;
  idpConfig?: any;
  useAD?: boolean;
}


let csClient: any;
let isAlert: boolean;
let errorMessage: string;
/**
 * Creates a network interface to use with redux-query
 * @param baseUrl
 */
export default function createCoreServicesNetworkInterface({
  apiUrl,
  signalrUrl,
  signalrApiUrl,
  onUnauthorized,
  getUsername,
  useIDP,
  idpConfig,
  useAD  
}: Config): NetworkInterface {
  csClient = new CoreServicesClient({
    baseURL: config.adminConfig.baseURL,
    signalrUrl: config.adminConfig.signalrUrl,
    signalrApiUrl: config.adminConfig.signalrApiUrl,
    onUnauthorized,
    getUsername,
    useIDP: config.useIDP,
    idpConfig,
    useAD: config.useAD  
  });

  return (url: string, method: string, { body, headers }: { body?: any; headers?: object } = {}): NetworkHandler => {
    const cancelSource = axios.CancelToken.source();
    isAlert = false;
    errorMessage = "";
    const requestConfig: any = { url, method, data: body, headers, cancelToken: cancelSource.token };
    if (method === GET && body) {
      requestConfig.params = body;
      delete requestConfig.data;
    }
    const request = csClient.request(requestConfig, useSignalR);
    const execute = async (cb: ExecuteCallback) => {
      try {
        const response: AxiosResponse = await request;
        const { status, headers: responseHeaders } = response;
        let data = response.data;

        // API is responding with stringified JSON, adding a workaround until this is fixed
        const contentType = responseHeaders['content-type'];
        if (
          typeof data === 'string' &&
          (contentType.indexOf('application/json') !== -1 || contentType === 'application/octet-stream')
        ) {
          data = JSON.parse(data);
        }

        cb(null, status, data, '', responseHeaders);
      } catch (err) {
        const { response = {} } = err;
        const { data, status, headers: responseHeaders } = response;
        if (status >= 300) {
          isAlert = true;
          if (data.Detail !== undefined && data.Detail !== "" && data.Detail !== null) {
            errorMessage = data.Detail;
            errorMessage = errorMessage.substring(0, 300) + " .....";
          }
          else
            errorMessage = data;
        }

        if (status === 401 && onUnauthorized) onUnauthorized();

        cb(err, status, data, '', responseHeaders);
      }
    };

    const abort = () => cancelSource.cancel();

    return {
      abort,
      execute,
    };
  };
}
export function updateAlert() {
  isAlert = false;
}
export { csClient, isAlert, errorMessage };
